import gql from 'graphql-tag';

const PROFILE_DOCUMENT= gql`
query profileDocument($id: ID!){
  profileDocument(id: $id)  {
   files{
    downloadUrl
  },
  name,
  type,
  validFrom,
  validTo,
  createdAt
  }
}
`;

export default PROFILE_DOCUMENT;